import { render, staticRenderFns } from "./DocumentTypeInformation.vue?vue&type=template&id=4a427b2e"
import script from "./DocumentTypeInformation.vue?vue&type=script&lang=js"
export * from "./DocumentTypeInformation.vue?vue&type=script&lang=js"
import style0 from "./DocumentTypeInformation.vue?vue&type=style&index=0&id=4a427b2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports